import { inject } from '@angular/core';
import { Dialog } from '@angular/cdk/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

export function closeDialogsOnNavigation(): void {
  const dialog = inject(Dialog);

  inject(Router)
    .events.pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(() => dialog.closeAll());
}
